import { SiteCard } from '../components/SiteCard';
import { Image, Cpu, CalendarCheck, ShoppingBag } from 'lucide-react';
import { useTheme } from '../hooks/useTheme';

const sites = [
  {
    title: 'Mockup Lab',
    description: 'Каталог мокапов и управление печатью. Загружай дизайны, применяй мокапы, выгружай результат.',
    href: 'https://mockup.witelab.ru',
    icon: Image,
    gradient: 'from-violet-500 to-indigo-600',
    glowColor: 'rgba(99, 102, 241, 0.15)',
    shadowColor: 'rgba(99, 102, 241, 0.25)',
    status: 'online' as const,
  },
  {
    title: 'AI Lab',
    description: 'Генерация изображений с помощью AI. Пакетная обработка, облачные задания, галерея.',
    href: 'https://ai.witelab.ru',
    icon: Cpu,
    gradient: 'from-emerald-400 to-cyan-500',
    glowColor: 'rgba(16, 185, 129, 0.15)',
    shadowColor: 'rgba(16, 185, 129, 0.25)',
    status: 'online' as const,
  },
  {
    title: 'Daily Lab',
    description: 'Ежедневник и задачи. Записи, теги, связи между заметками — как Obsidian, только в браузере.',
    href: 'https://daily.witelab.ru',
    icon: CalendarCheck,
    gradient: 'from-amber-400 to-orange-500',
    glowColor: 'rgba(245, 158, 11, 0.15)',
    shadowColor: 'rgba(245, 158, 11, 0.25)',
    status: 'online' as const,
  },
  {
    title: 'Ozon Lab',
    description: 'Управление заказами Ozon FBS. Чат с покупателями, макеты, отгрузка, работа с фото.',
    href: 'https://ozon.witelab.ru',
    icon: ShoppingBag,
    gradient: 'from-blue-500 to-indigo-600',
    glowColor: 'rgba(59, 130, 246, 0.15)',
    shadowColor: 'rgba(59, 130, 246, 0.25)',
    status: 'online' as const,
  },
];

export function Landing() {
  useTheme();
  return (
    <div className="min-h-screen relative overflow-hidden">
      {/* Background */}
      <div className="fixed inset-0 -z-10">
        <div className="absolute inset-0 bg-slate-950" />
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[600px] rounded-full bg-indigo-500/[0.07] blur-[120px] animate-glow" />
        <div className="absolute bottom-0 right-0 w-[500px] h-[400px] rounded-full bg-cyan-500/[0.05] blur-[100px]" />
      </div>

      {/* Content */}
      <div className="relative z-10 flex flex-col items-center min-h-screen px-6 py-16 sm:py-24">

        {/* Logo / Title */}
        <div className="animate-fade-in text-center mb-16 sm:mb-20">
          <div className="flex items-center justify-center gap-3 mb-4">
            <img src="/favicon/favicon.svg" className="w-14 h-14 sm:w-16 sm:h-16 object-contain" alt="Wite Lab" />
            <h1 className="text-5xl sm:text-6xl lg:text-7xl font-bold tracking-tight">
              <span className="text-gradient bg-gradient-to-r from-slate-100 via-slate-200 to-slate-400">
                wite lab
              </span>
            </h1>
          </div>
          <p className="text-slate-400 text-lg sm:text-xl font-light max-w-md mx-auto">
            Инструменты для работы и творчества
          </p>
        </div>

        {/* Site Cards Grid */}
        <div className="w-full max-w-5xl grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
          {sites.map((site, index) => (
            <SiteCard key={site.title} {...site} index={index} />
          ))}
        </div>

        {/* Footer */}
        <div className="mt-auto pt-16 sm:pt-24 text-center">
          <p className="text-slate-600 text-sm">
            &copy; {new Date().getFullYear()} wite lab
          </p>
        </div>
      </div>
    </div>
  );
}
